"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ErrorMessage = {
  NOT_FOUND: {
    status: 404,
    statusText: 'Page Missing',
    message: 'Allhomes cannot find the page that you have requested.'
  },
  SERVER_ERROR: {
    status: 500,
    statusText: 'Temporary Problem',
    message: 'Allhomes is having trouble servicing your request. Our technicians have been notified and will rectify the problem as soon as possible.'
  }
};
var _default = exports.default = ErrorMessage;